import ThreadViewer from '@admin/components/email_viewer/thread'
import Container from '@admin/components/container'

const mapResources = (props, context) => ({
  thread: `/api/admin/email/threads/${props.code}`
})

export default Container(mapResources)(ThreadViewer)
